(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["size-guide"] && !Shopify.designMode) return;
  try {
    (function () {
    var modal = document.getElementById('size-guide-modal');
    if (modal && modal.parentNode !== document.body) {
      document.body.appendChild(modal);
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
